import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './SimpleCertificationSection.css';

// Import certificate images
import CH0 from '../../images/events/CH0.jpg';
import CH1 from '../../images/events/CH1.jpg';
import CH1_1 from '../../images/events/CH1_1.jpg';
import CH2 from '../../images/events/CH2.jpg';
import CH2_1 from '../../images/events/CH2_1.jpg';
import CH3 from '../../images/events/CH3.jpg';
import CH3_1 from '../../images/events/CH3_1.jpg';
import CH4 from '../../images/events/CH4.jpg';
import CH4_1 from '../../images/events/CH4_1.jpg';
import CH5 from '../../images/events/CH5.jpg';
import CH6 from '../../images/events/CH6.jpg';
import CH6_1 from '../../images/events/CH6_1.jpg';
import CH7 from '../../images/events/CH7.jpg';
import CH8 from '../../images/events/CH8.jpg';
import CH8_1 from '../../images/events/CH8_1.jpg';
import CH9 from '../../images/events/CH9.jpg';
import CH10 from '../../images/events/CH10.jpg';
import CH10_1 from '../../images/events/CH10_1.jpg';
import CH11 from '../../images/events/CH11.jpg';
import CH11_1 from '../../images/events/CH11_1.jpg';
import CH12 from '../../images/events/CH12.jpg';
import CH13 from '../../images/events/CH13.jpg';
import CH14 from '../../images/events/CH14.jpg';
import CH14_1 from '../../images/events/CH14_1.jpg';
import CH15 from '../../images/events/CH15.jpg';
import CH16 from '../../images/events/CH16.jpg';
import CH16_1 from '../../images/events/CH16_1.jpg';
import CH17 from '../../images/events/CH17.jpg';
import CH18 from '../../images/events/CH18.jpg';
import CH19 from '../../images/events/CH19.jpg';
import CH20 from '../../images/events/CH20.jpg';
import CH21 from '../../images/events/CH21.jpg';
import CH22 from '../../images/events/CH22.jpg';
import CH23 from '../../images/events/CH23.jpg';
import CH24 from '../../images/events/CH24.jpg';
import CH25 from '../../images/events/CH25.png';

const SimpleCertificationSection = () => {
  const [selectedCert, setSelectedCert] = useState(null);

  const certifications = [
    {
      id: 1,
      title: "React Course: React, Next.js, Redux",
      issuer: "Udemy",
      year: "2025",
      image: CH0,
      category: "Development"
    },
    {
      id: 2,
      title: "Rest API(Intermediate)",
      issuer: "Hacker Rank",
      year: "2024",
      image: CH1,
      category: "API Development"
    },
    {
      id: 3,
      title: "AI with GitHub Copilot",
      issuer: "Udemy",
      year: "2024",
      image: CH1_1,
      category: "AI Development"
    },
    {
      id: 4,
      title: "SQL(Advanced)",
      issuer: "Hacker Rank",
      year: "2024",
      image: CH2,
      category: "Database"
    },
    {
      id: 5,
      title: "Angular - The Complete Guide(2025 Edition)",
      issuer: "Udemy",
      year: "2025",
      image: CH2_1,
      category: "Database"
    },
    {
      id: 6,
      title: "Software Engineer",
      issuer: "Hacker Rank",
      year: "2024",
      image: CH3,
      category: "Development"
    },
  {
      id: 7,
      title: "Certified Kubernetes Administrator(CKA)",
      issuer: "Udemy",
      year: "2025",
      image: CH3_1,
      category: "Devops"
    },
    {
      id: 8,
      title: "AWS Certified Developer - Associate(DVA-002)",
      issuer: "LinkedIn",
      year: "2024",
      image: CH4,
      category: "Cloud"
    },
    {
      id: 9,
      title: "Ultimate AWS Certified Developer Associate 2025",
      issuer: "Udemy",
      year: "2025",
      image: CH4_1,
      category: "Cloud"
    },
    {
      id: 10,
      title: "Access an EC2 Instance shell from the AWS console",
      issuer: "Coursera",
      year: "2024",
      image: CH5,
      category: "Cloud"
    },
    {
      id: 11,
      title: "Certified Kubernetes Administrator(CKA) with Practice Tests",
      issuer: "Udemy",
      year: "2024",
      image: CH5,
      category: "Cloud"
    },
    {
      id: 12,
      title: "Advanced Java Programming",
      issuer: "LinkedIn",
      year: "2024",
      image: CH6,
      category: "Development"
    },
    {
      id: 13,
      title: "Complete Software Engineering Course: Build Better Software",
      issuer: "LinkedIn",
      year: "2024",
      image: CH6_1,
      category: "Development"
    },
    {
      id: 14,
      title: "DevOps Foundations",
      issuer: "LinkedIn",
      year: "2024",
      image: CH7,
      category: "DevOps"
    },
    {
      id: 15,
      title: "DevOps Foundations: Continuous Integration/Continuous Delivery",
      issuer: "LinkedIn",
      year: "2024",
      image: CH8,
      category: "DevOps"
    },
    {
      id: 16,
      title: "Spring Boot Microservices Professional eCommerce Masterclass",
      issuer: "Udemy",
      year: "2025",
      image: CH8_1,
      category: "Development"
    },
    {
      id: 17,
      title: "GraphQL Essentials Training",
      issuer: "LinkedIn",
      year: "2024",
      image: CH9,
      category: "Development"
    },
    {
      id: 18,
      title: "Java Object-Oriented Programming",
      issuer: "LinkedIn",
      year: "2024",
      image: CH10,
      category: "Development"
    },
    {
      id: 19,
      title: "The Complete Python Bootcamp Course",
      issuer: "Udemy",
      year: "2025",
      image: CH10_1,
      category: "Development"
    },
    {
      id: 20,
      title: "Java Data Structures",
      issuer: "LinkedIn",
      year: "2024",
      image: CH11,
      category: "Development"
    },
    {
      id: 21,
      title: "Rest API Testing(Automation) from Scratch-Rest Assured Java",
      issuer: "Udemy",
      year: "2025",
      image: CH11_1,
      category: "Testing"
    },
    {
      id: 22,
      title: "Jenkins Essential Training",
      issuer: "LinkedIn",
      year: "2024",
      image: CH12,
      category: "DevOps"
    },
    {
      id: 23,
      title: "Learn Apache Kafka for Beginners",
      issuer: "LinkedIn",
      year: "2024",
      image: CH13,
      category: "Development"
    },
    {
      id: 24,
      title: "The Complete SQL Bootcamp",
      issuer: "Udemy",
      year: "2025",
      image: CH13,
      category: "Database"
    },
    {
      id: 25,
      title: "MongoDB Essentials Training",
      issuer: "Oracle",
      year: "2024",
      image: CH14,
      category: "Database"
    },
    {
      id: 26,
      title: "Docker & Kubernetes: The Practical Guide [2025 Edition]",
      issuer: "Udemy",
      year: "2025",
      image: CH14_1,
      category: "DevOps"
    },
    {
      id: 27,
      title: "Planning and Releasing Software with Jira",
      issuer: "LinkedIn",
      year: "2024",
      image: CH15,
      category: "Development"
    },
    {
      id: 28,
      title: "PostgreSQL Essentials Training",
      issuer: "LinkedIn",
      year: "2024",
      image: CH16,
      category: "Database"
    },
    {
      id: 29,
      title: "Testing Java:JUnit 5, Mockito, TestContainers, Rest Assured",
      issuer: "Udemy",
      year: "2025",
      image: CH16_1,
      category: "Testing"
    },
    {
      id: 30,
      title: "TyepeScript Essentials Training",
      issuer: "LinkedIn",
      year: "2024",
      image: CH17,
      category: "Development"
    },
    {
      id: 31,
      title: "Learning Spring with Spring Boot",
      issuer: "LinkedIn",
      year: "2024",
      image: CH18,
      category: "Development"
    },
    {
      id: 32,
      title: "React Course 2025 - React, Next.js, Redux",
      issuer: "Udemy",
      year: "2025",
      image: CH19,
      category: "Development"
    },
    {
      id: 33,
      title: "GitLab CI: Pipelines, CI/CD and DevOps for Beginners",
      issuer: "Udemy",
      year: "2025",
      image: CH20,
      category: "Development"
    },
    {
      id: 34,
      title: "Rest Api Testing(Automation) from Scratch-Rest Assured Java",
      issuer: "Udemy",
      year: "2025",
      image: CH21,
      category: "Testing"
    },
    {
      id: 35,
      title: "Angular - The Complete Guide(2025 Edition)",
      issuer: "Udemy",
      year: "2025",
      image: CH22,
      category: "Development"
    },
    {
      id: 36,
      title: "Ultimate AWS Certified Cloud Practitioner 2025",
      issuer: "Udemy",
      year: "2025",
      image: CH23,
      category: "Cloud"
    },
    {
      id: 37,
      title: "Postman API Fundamentals",
      issuer: "Udemy",
      year: "2025",
      image: CH24,
      category: "Testing"
    },
    {
      id: 38,
      title: "Graph Developer - Associate",
      issuer: "Apollo GraphQL",
      year: "2025",
      image: CH25,
      category: "Testing"
    }
  ];

  return (
    <section className="simple-cert-section" id="certifications">
      <div className="cert-container">
        {/* Section Header */}
        <motion.div
          className="cert-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="cert-title">Professional Certifications</h2>
          <p className="cert-subtitle">
            Industry-recognized certifications demonstrating expertise across multiple technologies
          </p>
          <div className="cert-stats-simple">
            <span className="cert-count">{certifications.length} Certifications</span>
            <span className="cert-year">2022-2025</span>
          </div>
        </motion.div>

        {/* Certifications Grid */}
        <motion.div
          className="cert-grid-simple"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {certifications.map((cert, index) => (
            <motion.div
              key={cert.id}
              className="cert-card-simple"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.03 }}
              viewport={{ once: true }}
              whileHover={{ y: -5, scale: 1.02 }}
              onClick={() => setSelectedCert(cert)}
            >
              <div className="cert-image-wrapper">
                <img src={cert.image} alt={cert.title} className="cert-image-simple" />
                <div className="cert-overlay-simple">
                  <i className="fas fa-eye"></i>
                </div>
              </div>
              <div className="cert-info-simple">
                <div className="cert-category-badge">{cert.category}</div>
                <h4 className="cert-name">{cert.title}</h4>
                <p className="cert-issuer">{cert.issuer}</p>
                <span className="cert-year-badge">{cert.year}</span>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Modal for full view */}
        {selectedCert && (
          <motion.div
            className="cert-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedCert(null)}
          >
            <motion.div
              className="cert-modal-content"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="cert-modal-close"
                onClick={() => setSelectedCert(null)}
              >
                <i className="fas fa-times"></i>
              </button>
              <img
                src={selectedCert.image}
                alt={selectedCert.title}
                className="cert-modal-image"
              />
              <div className="cert-modal-info">
                <div className="cert-modal-category">{selectedCert.category}</div>
                <h3>{selectedCert.title}</h3>
                <p>Issued by {selectedCert.issuer}</p>
                <span className="cert-modal-year">{selectedCert.year}</span>
              </div>
            </motion.div>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default SimpleCertificationSection;
